SupportServiceActionsBaseView = require('./service_action_base')
SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache')

class SupportCancelReservationsServiceActionView extends SupportServiceActionsBaseView
  id: 'cancel_reservation'

  initialize: ->
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportServiceActionButtonTemplate
    @order = Groupon.Support.currentOrder

  render: ->
    @$el.append toHtml(@template, @toHash(), @I18nScope)

  toHash: ->
    hash =
      service_action_id : "cancel_reservation"
      service_action : I18n.t("js.modules.support.cancel_reservation")
    @extendHash(hash)

  actionHandler: (event)->
    url = "/users/#{ currentUser.id }/groupons"
    openLocation url

  events :
    "click #cancel_reservation" : "actionHandler"

module.exports = SupportCancelReservationsServiceActionView
